import { FC, useEffect, useState } from 'react';
import clx from 'classnames';
import { Button } from 'src/Components';
import { SimpleSelect } from 'src/Components/Controls';
import { MONTH_NAMES } from '..';
import { ReactComponent as Shevron } from 'src/Themes/assets/chevron-left.svg';
import st from "./CalendarControl.module.scss";

interface ICalendarControlProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
	/** Только для чтения */
	readOnly?: boolean;
	/** Минимальная дата доступная */
	minDate: Date;
	/** Максимальная дата доступная */
	maxDate: Date;
	/** Месяц календаря */
	month: number;
	/** Год календаря */
	year: number;
	/** Установить месяц */
	setMonth: ( value: number ) => void;
	/** Установить год */
	setYear: ( value: number ) => void;
};

/** Компонента для управлением календарем */
const CalendarControl: FC<ICalendarControlProps> = ( props ) => {

	const {  
		readOnly, minDate, maxDate, month, year,
		setMonth, setYear,
		className, ...otherProps
	} = props;

	// Массив с доступными для выбора годами
	const [ yearList, setYearList ] = useState<Array<number>>([]);

	/** При монтировании компонента, вычисляем список доступных годов  */
	useEffect( () => {
		const years = Array(maxDate.getFullYear() - minDate.getFullYear() + 1)
			.fill(0)
			.map((_, index) => (maxDate.getFullYear() - index));
		setYearList(years);
	// eslint-disable-next-line
	}, []);

	/** Слайд месяцев  */
	const changeMonth = ( inc: number ) => {
		let curMonth = month + inc;
		let curYear = year;
	
		if (curMonth === 12) {
			curMonth = 0;
			curYear++;
		} 
		else if (curMonth === -1) {
			curMonth = 11;
			curYear--;
		}
	
		setMonth(curMonth);
		setYear(curYear);
	};

	const isDisabled = ( dir: "-" | "+" ): boolean => {
		if ( readOnly ) return true;
		if ( dir === "-" )
			return minDate.getFullYear() === year && minDate.getMonth() === month;
		else if ( dir === "+" )
			return maxDate.getFullYear() === year && maxDate.getMonth() === month;
		return true;
	};

	return (
		<div className={clx(st.controls, className)} {...otherProps}>
			
			<SimpleSelect
				options={MONTH_NAMES}
				value={month} setValue={ (e) => setMonth(+e) }
				placeholder="Месяц"
				disabled={readOnly}
			/>
			<SimpleSelect
				style={{ minWidth: '94px' }}
				options={yearList}
				value={year}
				setValue={ (e) => setYear(+e) }
				disabled={readOnly}
			/>
			
			<div className={st.navbtns}>
				<Button outline size="min" disable={isDisabled("-")} onClick={() => changeMonth(-1)}>
					<Shevron width={24} />
				</Button>
				<Button outline size="min" disable={isDisabled("+")} onClick={() => changeMonth(+1)}>
					<Shevron width={24} />
				</Button>
			</div>

		</div>
	);
};

export default CalendarControl;
